import { useState, useEffect } from "react";

export const useDayNotes = (code, day) => {
  const key = `alania_day_${code}_${day}`;
  const read = () => { try { return JSON.parse(localStorage.getItem(key)) || {}; } catch { return {}; } };
  const [notes, setNotes] = useState(read);
  useEffect(() => { setNotes(read()); }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  const update = (patch) => setNotes((n) => { const v = { ...n, ...patch }; localStorage.setItem(key, JSON.stringify(v)); return v; });
  return [notes, update];
};
